// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { at16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-at': IconAt;
    }
}

/**
 * The icon component for the 'at' icon
 */
export class IconAt extends IconSvg {
    public constructor() {
        super(at16X16);
    }
}

registerIconSvg('icon-at', IconAt);
export const iconAtTag = 'nimble-icon-at';
